import styled from '@emotion/styled';
import { Button } from 'ds/components/button';
import { H3, Text } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';

export const SectionForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 400px;
  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(7)} ${theme.spacing(4)}`};
  align-items: center;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 100%;
    padding: 0;
  `}
`;

export const PopupTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(4)};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 100%;
    text-align: right;
  `}
`;

export const FormTitle = styled(H3)`
  text-align: right;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;

export const TitleWithClose = styled.div`
  text-align: center;
  position: relative;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutrals.grey6};
  padding: ${({ theme }) => theme.spacing(2)} 0;
  font-size: 15px;
  svg {
    cursor: pointer;
    position: absolute;
    left: 24px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing(2.5)} ${theme.spacing(5)}`};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: ${`${theme.spacing(2)} ${theme.spacing(1)}`};
  `}
`;

export const BottomText = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  margin-left: ${({ theme }) => theme.spacing(10)};
  white-space: nowrap;
  flex-shrink: 0;
`;

export const PhoneButton = styled(Button.withComponent('a'))`
  color: ${({ theme }) => theme.colors.brand.main};
  text-decoration: none;
`;

export const Logo = styled.div`
  width: 48px;
  height: 48px;
  line-height: 0;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background: ${({ theme }) => theme.colors.neutrals.white};
  padding: ${({ theme }) => theme.spacing(0.5)};
  box-shadow: 0 0 1px 0 ${({ theme }) => colorToAlpha(theme.colors.neutrals.grey1, 0.3)};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: ${({ theme }) => theme.borderRadius.tiny};
    overflow: hidden;
  }
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 72px;
    height: 72px;
  `}
`;

export const FormWrapper = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing(3)};
  grid-template-columns: 1fr;
  width: 100%;
  .textfield-input {
    background: ${({ theme }) => theme.colors.neutrals.grey11};
    padding-right: ${({ theme }) => theme.spacing(1.5)};
    padding-left: ${({ theme }) => theme.spacing(4)};
  }
  && .textfield-icon {
    right: auto;
    left: 8px;
    svg {
      path {
        fill: ${({ theme }) => theme.colors.neutrals.grey1};
      }
    }
  }
`;

export const ModalCloseWrapper = styled.div`
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(3)}`};
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 -4px 10px 0 ${({ theme }) => colorToAlpha(theme.colors.neutrals.black, 0.05)};
`;
